import React from 'react';
export function HeroSection() {
  return <section className="relative w-full min-h-screen flex flex-col text-center px-5 py-8 sm:py-14 items-center justify-center" style={{
    background: 'linear-gradient(135deg, #0a0a0a 0%, #1a0d00 30%, #0d0800 60%, #0a0a0a 100%)'
  }} data-id="element-72">
      {/* Logo */}
      <div className="mb-3" data-id="element-73">
        <span className="text-[#FF6B00] text-xl sm:text-2xl font-black tracking-widest" data-id="element-74">
          🌟 PROFEPACK
        </span>
      </div>

      {/* Main headline */}
      <h1 className="font-black text-white max-w-5xl sm:text-5xl md:text-7xl lg:text-8xl mb-1 text-[32px] leading-tight" data-id="element-75">
        Todo tu año de Inglés
        <br data-id="element-76" />
        <span className="text-[#FF6B00]" data-id="element-77">resuelto.</span>
      </h1>

      {/* Mockup image */}
      <div className="w-full max-w-[220px] sm:max-w-[300px] md:max-w-[340px] mx-auto my-4 sm:my-5" data-id="element-78">
        <img src="https://cdn.magicpatterns.com/uploads/iFJS33CsZZfWhfFFdUqu6F/Sin_titulo_(420_x_420_px)_(3).png" alt="PROFEPACK Megapack Inglés Listo - Combo Completo" className="w-full h-full object-contain" width={400} height={400} fetchPriority="high" style={{
        aspectRatio: '1/1'
      }} data-id="element-79" />
      </div>

      {/* Value prop */}
      <p className="text-white sm:text-xl max-w-xl mb-3 text-[16px] leading-relaxed" data-id="element-80">
        El sistema que usan{' '}
        <strong className="text-[#FF6B00]" data-id="element-81">+3.000 docentes</strong> para
        planificar todo el año en una tarde — sin improvisar ni perder domingos.
      </p>

      {/* Pills */}
      <div className="flex flex-nowrap mb-4 gap-2 items-center justify-center" data-id="element-82">
        <span className="bg-black/50 border border-[#FF6B00]/40 text-white text-[11px] sm:text-sm font-semibold px-2.5 sm:px-3 py-1 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-83">
          📄 100% PDF
        </span>
        <span className="bg-black/50 border border-[#FF6B00]/40 text-white text-[11px] sm:text-sm font-semibold px-2.5 sm:px-3 py-1 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-84">
          ⚡ Acceso inmediato
        </span>
        <span className="bg-black/50 border border-[#FF6B00]/40 text-white text-[11px] sm:text-sm font-semibold px-2.5 sm:px-3 py-1 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-85">
          🇦🇷 Currículo argentino
        </span>
      </div>

      {/* CTA Button */}
      <a href="#pricing" className="btn-orange-pulse bg-[#FF6B00] font-black text-[15px] sm:text-2xl px-6 sm:px-10 py-4 sm:py-5 rounded-xl hover:bg-orange-400 transition-colors inline-block mb-4 sm:w-auto text-white shadow-[0_0_30px_rgba(255,107,0,0.3)] whitespace-nowrap" data-id="element-86">
        🌟 QUIERO MI PROFEPACK AHORA
      </a>

      {/* Trust badges */}
      <p className="text-gray-400 text-xs sm:text-sm flex flex-wrap items-center justify-center gap-2.5 sm:gap-3" data-id="element-87">
        <span data-id="element-88">🛡️ Garantía 7 días</span>
        <span data-id="element-89">🔒 Pago seguro</span>
        <span data-id="element-90">💳 Mercado Pago</span>
      </p>
    </section>;
}